import { useMemo } from 'react';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';

export const useCreateFundExchangeRateSheet = () => {
  const fundExchangeRateSheet = useMemo(() => {
    const columns = [{}]
    const rowConfig = [{
      alias:  'fundExchangeRate',  
    }]
    const parser = () => ({
      'A1': {
        alias: 'fundExchangeRate',
        key: 'A1',
        customKey: 'fundExchangeRate',
        rowNumber: 1,
        columnLegend: 'A',
        value: 1
      }
    })
    return new SpreadsheetConfig({
      columns,
      rowConfig,
      tableData: {},
      parser,
      name: 'ExchangeRateSheet',
      reverseParser: () => {},
    })
  }, [])

  return {fundExchangeRateSheet}
}